"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramsService = void 0;
class ProgramsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Returns SE Creator programs information.
     * @returns SECreatorProgramResponse
     * @throws ApiError
     */
    getSePrograms() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/programs/',
        });
    }
    /**
     * Paginate list of programs info
     * @param page
     * @param count
     * @returns ListSEProgramsResponse
     * @throws ApiError
     */
    listSePrograms(page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/programs/list',
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * Paginate list of creator info by program id
     * @param id program uuid
     * @param page
     * @param count
     * @returns ListProgramCreatorsResponse
     * @throws ApiError
     */
    listCreatorsOfProgram(id, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/programs/{id}',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
}
exports.ProgramsService = ProgramsService;
